var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7617 0.291016H2.52907C1.13808 0.291016 0 1.4291 0 2.82009V23.0527C0 24.4437 1.13808 25.5817 2.52907 25.5817H22.7617C24.1526 25.5817 25.2907 24.4437 25.2907 23.0527V2.82009C25.2907 1.4291 24.1526 0.291016 22.7617 0.291016ZM7.58722 21.7881H3.79361V10.4073H7.58722V21.7881ZM5.69041 8.25759C4.42588 8.25759 3.41425 7.24597 3.41425 5.98143C3.41425 4.71689 4.42588 3.70526 5.69041 3.70526C6.95495 3.70526 7.96658 4.71689 7.96658 5.98143C7.96658 7.24597 6.95495 8.25759 5.69041 8.25759ZM21.4971 21.7881H17.7035V15.0861C17.7035 14.0745 16.8183 13.1893 15.8067 13.1893C14.7951 13.1893 13.9099 14.0745 13.9099 15.0861V21.7881H10.1163V10.4073H13.9099V11.9248C14.5422 10.9131 15.9332 10.1544 17.0712 10.1544C19.4739 10.1544 21.4971 12.1777 21.4971 14.5803V21.7881Z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinGrey);
export default __webpack_public_path__ + "static/media/linkedin_grey.0bd1ca4ec341621e28ba21850af3f526.svg";
export { ForwardRef as ReactComponent };